import DEV from "./DEV.js";
export { DEV };
import { removeTemporaryGlobals } from "./graphql.js";
export { removeTemporaryGlobals };
removeTemporaryGlobals();
//# sourceMappingURL=index.js.map